import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {Form, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {City, County, JobCompetents, JobDepartments, JobModel} from '../../models/job.model';
import {JobTypeModel} from '../../models/jobType.model';
import {MAT_DIALOG_DATA} from '@angular/material/typings/dialog';
import {MatCheckboxChange, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material';
import {JobTypeService} from '../../services/jobType.service';
import {ValidationMessageService} from '../../../shared/services/validation-message-handle';
import {ToastrService} from 'ngx-toastr';
import {JobService} from '../../services/job.service';
import {CityService} from '../../services/city.service';
import {CountyService} from '../../services/county.service';
import {finalize} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {DeleteDialogComponent} from '../../../shared/components/delete-dialog/delete-dialog.component';
import {UserService} from '../../../auth/services/user.service';
import {UserModel} from '../../../auth/models/user.model';
import {confirmPasswordValidator} from '../../../auth/reset-password/reset-password.component';
import {UserProfileModel} from '../../../auth/models/user-profile.model';
import {CompanyModel} from '../../../auth/models/company.model';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';
import {HttpApiService} from '../../../shared/services/http-api.service';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit, OnDestroy {

  public objectForm: FormGroup;
  public companyForm: FormGroup;
  public userProfileContainerWidth: string = '100';
  public loading: boolean = false;
  public entityTypeList: Array<string> = ['admin', 'student', 'angajator', 'universitate'];
  public selectedEntityType: any = '';

  public cvUrl: string = null;
  public documentUrl: string = null;

  constructor(
      @Inject(MAT_DIALOG_DATA)
      public thisObject: UserModel,
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<CreateUserComponent>,
      private _formBuilder: FormBuilder,
      private validationMessageService: ValidationMessageService,
      private toastr: ToastrService,
      private userService: UserService,
      private httpApiService: HttpApiService,
  ) {

  }

  ngOnInit(): void {

    this.objectForm = this._formBuilder.group({
      name: ['', Validators.required],
      email: [{value: '', disabled: !!(this.thisObject)}, Validators.required],
      password: [''],
      password_confirmation: ['', confirmPasswordValidator],
      entityType: ['', Validators.required],
      isActive: [true],
      isAdmin: [],
    });

    this.companyForm = this._formBuilder.group({
      name: ['', Validators.required],
      uniqueRegistrationCode: ['', Validators.required],
      nrRegCom: ['', Validators.required],
    });

    if (this.thisObject) {

      if (this.thisObject.entityType === 'student') {
        this.userProfileContainerWidth = '100';
      } else {
        this.userProfileContainerWidth = '50';
      }
      this.objectForm.patchValue({
        name: this.thisObject.name,
        email: this.thisObject.email,
        entityType: this.thisObject.entityType,
        isActive: this.thisObject.isActive,
        isAdmin: this.thisObject.isAdmin,
      });

      if (this.thisObject.company) {
        this.companyForm.patchValue({
          name: this.thisObject.company.name,
          uniqueRegistrationCode: this.thisObject.company.uniqueRegistrationCode,
          nrRegCom: this.thisObject.company.nrRegCom
        });
      }

      this.selectedEntityType = this.thisObject.entityType;

      this.getEntityDocuments();

    }
  }

  ngOnDestroy(): void {

  }

  create(): void {

    const data = new UserProfileModel();
    data.user = new UserModel().map(this.objectForm.getRawValue());
    data.user.entityType = this.selectedEntityType;
    data.company = new CompanyModel().map(this.companyForm.getRawValue());

    this.loading = true;
    this.userService.create(data)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.toastr.success('Succes!', 'Utilizatorul a fost salvata cu succes!');
          this.dialogRef.close(data);
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, 'user.', true);
            this.validationMessageService.serverSideValidation(err, this.companyForm, 'company.', true);
          }
        });
  }

  update(): void {

    const data = new UserProfileModel();

    data.user = new UserModel().map(this.objectForm.getRawValue());
    data.user.uid = this.thisObject.uid;
    data.user.entityType = this.selectedEntityType;
    data.company = new CompanyModel().map(this.companyForm.getRawValue());

    this.loading = true;
    this.userService.updateUserProfile(data)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.toastr.success('Succes!', 'Utilizatorul a fost modificata cu succes!');
          this.dialogRef.close(data);
        }, err => {
          if (err instanceof HttpErrorResponse) {
            this.validationMessageService.serverSideValidation(err, this.objectForm, 'user.', true);
            this.validationMessageService.serverSideValidation(err, this.companyForm, 'company.', true);
          }
        });
  }

  onClickSave(): void {

    if (this.thisObject) {
      this.update();
    } else {
      this.create();
    }

  }

  onClickCancel(): void {
    this.dialogRef.close();

  }

  onDeleteClick(): void {

    const dialogConfig = new MatDialogConfig();

    this.dialog.open(DeleteDialogComponent, dialogConfig).afterClosed().subscribe(result => {

      if (result === true) {
        const data = new UserModel().map(this.objectForm.getRawValue());
        data.uid = this.thisObject.uid;
        this.loading = true;
        this.userService.delete(data)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response) => {
              this.toastr.success('Succes!', 'Utilizatorul a fost sters cu succes!');
              this.dialogRef.close(this.objectForm.getRawValue());
            }, err => {
              if (err instanceof HttpErrorResponse) {
                this.validationMessageService.serverSideValidation(err, this.objectForm, 'user.', true);
                this.validationMessageService.serverSideValidation(err, this.companyForm, 'company.', true);
              }
            });
      }
    });
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o1 && o2) {
      return o1 === o2;
    } else {
      return false;
    }
  }

  onIsAdminChange($event: MatCheckboxChange): void {
    if ($event) {
      this.selectedEntityType = 'admin';
    }
  }

  onEntityTypeChange($event: any): void {

    this.objectForm.patchValue({
      isAdmin: ($event === 'admin') ? true : false,
    });

  }

  validateForm(): boolean {

    if (this.selectedEntityType === 'student'){
      return this.objectForm.invalid;
    }else{
      return this.objectForm.invalid && this.companyForm.invalid;
    }

  }


  getEntityDocuments(): void
  {

    this.loading = true;


    if ( this.selectedEntityType === 'student' ) {

      this.httpApiService.getFile('User', 'cv', this.thisObject.uid, false)
          .pipe(finalize(() => this.loading = false))
          .subscribe((response: ApiResponseModel) => {

            if (response.payload){
              const media = response.payload[response.payload.length - 1];
              console.log(this.selectedEntityType, response.payload, media);
              this.cvUrl = media.url;
            }

          });

    } else {

      this.httpApiService.getFile('User', 'delegation', this.thisObject.uid, false)
          .pipe(finalize(() => this.loading = false))
          .subscribe((response: ApiResponseModel) => {

            if (response.payload){
              const media = response.payload[response.payload.length - 1];
              console.log(this.selectedEntityType, response.payload, media);
              this.documentUrl = media.url;
            }

          });

    }
  }

  openCv(): void {
    window.open(this.cvUrl, '_blank');
  }


  openDelegationCompanyDocument(): void {
    window.open(this.documentUrl, '_blank');
  }
}
